<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
  <div class="service_se">
    <div class="heading_sert">
      <h3>Business hours</h3>
    </div>
    <div class="chip_services_list">
      <mat-chip-list>
        <mat-chip
          (click)="selectBusiness(i)"
          *ngFor="let item of businessListData; let i = index"
          [ngClass]="{ 'Graceful-box-active': item.isSelected == 1 }"
          >{{ item.name }}</mat-chip
        >
      </mat-chip-list>
    </div>
  </div>

  <div class="service_create_sd">
    <div class="row">
      <div class="col-sm-9">
        <div class="serv_heading">
          <h3>
            {{
              selectedServiceType == "0"
                ? "Home Service Timings"
                : selectedServiceType == "1"
                ? "Shop Service Timings"
                : "Virtual Service Timings"
            }}
            of {{ selectedBusiness.name }}
          </h3>
          <p>{{ selectedBusiness.address_line }}</p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="select_thth">
          <mat-form-field appearance="outline">
            <mat-label>Select Timing</mat-label>
            <mat-select
              [(ngModel)]="selectedServiceType"
              (selectionChange)="onSelectChange($event)"
            >
              <mat-option
                value="1"
                *ngIf="selectedBusiness.shop_service_status != 2"
                >Shop Service Timings</mat-option
              >
              <mat-option
                value="0"
                *ngIf="selectedBusiness.home_service_status != 2"
                >Home Service Timings</mat-option
              >
              <mat-option
                value="2"
                *ngIf="selectedBusiness.virtual_service_status != 2"
                >Virtual Service Timings</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div
    class="schedule-container"
    *ngIf="groupedServiceTimings && toShowTimings && !hidediv"
  >
    <div class="header_services">
      <div class="day_sp">
        <p class="td_header">Day</p>
      </div>
      <div class="day_sp session_otp">
        <p class="td_header">Session</p>
      </div>
      <div class="day_sp session_otp">
        <p class="td_header">Start Time</p>
      </div>
      <div class="day_sp session_ppt">
        <p class="td_header">Stop Time</p>
      </div>
      <div class="day_sp session_ppt" *ngIf="selectedServiceType == '2'">
        <p class="td_header">Meeting Info</p>
      </div>
      <div class="option_mn"></div>
    </div>

    <div *ngFor="let item of groupedServiceTimings; let i = index">
      <div class="body_services" *ngIf="item.timelist.length > 1">
        <div
          class="or_nxt"
          *ngFor="let element of item.timelist; let j = index"
          [ngClass]="{ repectv: j > 0 }"
        >
          <div class="day_sp">
            <p class="fun_bt days_t">
              {{ element.toShowType == "parent" ? element.dayName : "" }}
            </p>
          </div>
          <div class="day_sp">
            <p>{{ j + 1 }}</p>
          </div>
          <div class="day_sp">
            <p>{{ element.openTime }}</p>
          </div>
          <div class="day_sp">
            <p>{{ element.closeTime }}</p>
          </div>
          <div class="day_sp" *ngIf="selectedServiceType == '2'">
            <div *ngIf="element.meeting_details">
              <mat-icon
                style="color: green"
                *ngIf="
                  element.meeting_details[0].meeting_details &&
                  element.meeting_details[0].meeting_details != '' &&
                  element.meeting_details[0].meeting_details != 'null'
                "
                >task_alt</mat-icon
              >
            </div>
          </div>
          <div class="option_mn">
            <button
              mat-icon-button
              [matMenuTriggerFor]="homeMenu1"
              *ngIf="
                selectedBusiness.is_owner == 1 || selectedServiceType == '2'
              "
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #homeMenu1="matMenu">
              <button
                mat-menu-item
                *ngIf="element.status == 0 && selectedBusiness.is_owner == 1"
                (click)="openAddTime(element)"
              >
                <mat-icon class="material-icons-outlined">add</mat-icon>
                <span>{{ "service_timings.opt_add_time" | translate }}</span>
              </button>
              <button
                mat-menu-item
                (click)="openAddTime(element)"
                *ngIf="
                  element.status == 1 &&
                  element.toShowType == 'parent' &&
                  selectedBusiness.is_owner == 1
                "
              >
                <mat-icon class="material-icons-outlined">add</mat-icon> Add
                more
              </button>
              <button
                mat-menu-item
                (click)="removeTime(element)"
                *ngIf="element.status == 1 && selectedBusiness.is_owner == 1"
              >
                <mat-icon class="material-icons-outlined">delete</mat-icon
                >Delete
              </button>
              <button
                mat-menu-item
                *ngIf="element.status == 1 && selectedServiceType == '2'"
                (click)="openAddEditMeetingDetails(element)"
              >
                <mat-icon class="material-icons-outlined">video_chat</mat-icon
                >Meeting info
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div class="body_services" *ngIf="item.timelist.length == 1">
        <div
          class="or_nxt"
          *ngFor="let element of item.timelist; let j = index"
        >
          <div class="day_sp">
            <p class="fun_bt days_t">
              {{ element.toShowType == "parent" ? element.dayName : "" }}
            </p>
          </div>
          <div class="day_sp">
            <p>{{ j + 1 }}</p>
          </div>
          <div class="day_sp">
            <p>{{ element.openTime }}</p>
          </div>
          <div class="day_sp">
            <p>{{ element.closeTime }}</p>
          </div>
          <div class="day_sp" *ngIf="selectedServiceType == '2'">
            <div *ngIf="element.meeting_details">
              <mat-icon
                style="color: green"
                *ngIf="
                  element.meeting_details[0].meeting_details &&
                  element.meeting_details[0].meeting_details != '' &&
                  element.meeting_details[0].meeting_details != 'null'
                "
                >task_alt</mat-icon
              >
            </div>
          </div>
          <div class="option_mn">
            <button
              mat-icon-button
              [matMenuTriggerFor]="homeMenu"
              *ngIf="
                selectedBusiness.is_owner == 1 || selectedServiceType == '2'
              "
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #homeMenu="matMenu">
              <button
                mat-menu-item
                *ngIf="element.status == 0 && selectedBusiness.is_owner == 1"
                (click)="openAddTime(element)"
              >
                <mat-icon class="material-icons-outlined">add</mat-icon>
                <span>{{ "service_timings.opt_add_time" | translate }}</span>
              </button>
              <button
                mat-menu-item
                (click)="openAddTime(element)"
                *ngIf="
                  element.status == 1 &&
                  element.toShowType == 'parent' &&
                  selectedBusiness.is_owner == 1
                "
              >
                <mat-icon class="material-icons-outlined">add</mat-icon> Add
                more
              </button>
              <button
                mat-menu-item
                (click)="removeTime(element)"
                *ngIf="element.status == 1 && selectedBusiness.is_owner == 1"
              >
                <mat-icon class="material-icons-outlined">delete</mat-icon
                >Delete
              </button>
              <button
                mat-menu-item
                [disabled]="element.status == 0"
                *ngIf="(element.status == 1 && selectedServiceType == '2') || selectedBusiness.is_owner == 0"
                (click)="openAddEditMeetingDetails(element)"
              >
                <mat-icon class="material-icons-outlined">video_chat</mat-icon
                >Meeting info
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>

    <!-- new section added -->
    <div class="set_unbilty" *ngIf="selectedBusiness.is_owner == 1 && !hidediv">
      <mat-card>
        <div class="unb_heading">
          <h3>Set unavailability</h3>
          <p>
            Manage your shop/service unavailability based on selected dates.
            Customers wouldn't be able to book appointments on those days.
          </p>
        </div>
        <div class="set_yyt_btn">
          <button mat-flat-button (click)="configureUnavailability()">
            Configure dates
          </button>
        </div>
      </mat-card>
    </div>
    <!-- new section added -->
  </div>

  <!-- Placeholder design html start -->
  <div
    class="placeholder_started"
    *ngIf="(!groupedServiceTimings || !toShowTimings) && !hidediv"
  >
    <div class="row">
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/service-hour-placeholder.jpg" />
              </div>
              <mat-card-title>No timings added</mat-card-title>
              <mat-card-content
                >You haven't added any service hours for your
                {{
                  this.selectedServiceType == "0"
                    ? "home"
                    : this.selectedServiceType == "1"
                    ? "shop"
                    : "virtual"
                }}
                service offerings. Add them to get bookings and business.
              </mat-card-content>
              <div class="create_btnyh">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="changeTimingsViewStatus()"
                  *ngIf="selectedBusiness.is_owner == 1"
                >
                  <mat-icon>add</mat-icon>
                  Add
                  {{
                    this.selectedServiceType == "0"
                      ? "home"
                      : this.selectedServiceType == "1"
                      ? "shop"
                      : "virtual"
                  }}
                  timings
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/service-hours-3.png" />
              </div>
              <mat-card-title>How to add service hours?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on adding service hours against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in adding service hours or if there's any
                issue while adding them, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->
</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
  <!-- <div class="service_se">
        <div class="heading_sert">
            <h3>Service hours</h3>
        </div>
        
    </div> -->
  <!-- Placeholder design html start -->
  <div class="placeholder_started">
    <div class="row">
      <div class="heading_sert">
        <h3>Service hours</h3>
      </div>
      <div
        class="col-sm-4"
        *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>No business added yet</mat-card-title>
              <mat-card-content
                >To add your service hours you need to create a business first.
                Service hours will be added under that business.
              </mat-card-content>
              <!-- <mat-card-title>No timings added</mat-card-title>
               <mat-card-content>You haven't added any service hours  for your home service offerings. Add them to get bookings and business.
              </mat-card-content> -->
              <div class="create_btnyh">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="selectcountry()"
                >
                  <mat-icon>add</mat-icon>
                  Create a business
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined" style="">
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>Access denied.</mat-card-title>
              <mat-card-content>
                Business owner with valid premium business subscription or an
                active employee can access this section. Check current plans.
                Recharge pack if expired.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/service-hours-3.png" />
              </div>
              <mat-card-title>How to add service hours?</mat-card-title>
              <mat-card-content
                >Check our
                <a
                  href="https://lookzup.com/help"
                  target="_blank"
                  class="ghtunderline"
                >
                  help document
                </a>
                on adding service hours against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in adding service hours or if there's any
                issue while adding them, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->
</section>
